export default {
    USER_ID: "user_FiKNsMoeiup7qboUmf64Y",
    TEMPLATE_ID: "template_tk0bakf"
}